import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfigRoutingModule } from './config-routing.module';
import { ConfigComponent } from './config.component';

import { SharedModule } from '../../shared/shared.module';
import { SitesComponent } from './sites/sites.component';
import { StatesComponent } from './states/states.component';
import { ScheduledMaintenanceGeneratorComponent } from './scheduledMaintenanceGenerator/scheduledMaintenanceGenerator.component';
import { ManageMacsComponent } from "./manageMacs/manageMacs.component";
import { ManageUsersComponent } from "./manageUsers/manageUsers.component";
import { PasswordComponent } from './password/password.component';
import { CacheComponent } from './cache/cache.component';


@NgModule({
  imports: [
    CommonModule,
    ConfigRoutingModule,
    SharedModule
  ],
  declarations: [
    ConfigComponent,
    SitesComponent,
    StatesComponent,
    ScheduledMaintenanceGeneratorComponent,
    ManageMacsComponent,
    ManageUsersComponent,
    PasswordComponent,
    CacheComponent
  ]
})
export class ConfigModule { }
